"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypesActions = exports.StatusesActions = exports.DashboardActions = void 0;
const _DashboardActions = require("../../modules/dashboard/actions");
const _StatusesOrTypesActions = require("../../modules/project/statusesOrTypes/actions");
require("./home");
require("./members");
require("./permissions");
require("./wizard");
require("./copy");
require("./delete");
require("./users");
require("./customerUserGroups");
exports.DashboardActions = _DashboardActions.default('project');
exports.StatusesActions = _StatusesOrTypesActions.default('project-statuses');
exports.TypesActions = _StatusesOrTypesActions.default('project-types');
//# sourceMappingURL=index.js.map